// extracted by mini-css-extract-plugin
export default {"container":"loading_container_container__G4hhk","overlayText":"loading_container_overlayText__tjyt5"};